import { render } from "./FloorDocuments.vue?vue&type=template&id=c554fe96&scoped=true"
import script from "./FloorDocuments.vue?vue&type=script&lang=js"
export * from "./FloorDocuments.vue?vue&type=script&lang=js"

import "./FloorDocuments.vue?vue&type=style&index=0&id=c554fe96&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c554fe96"]])

export default __exports__